import { render, staticRenderFns } from "./FooterNavigation.vue?vue&type=template&id=0e71a604&scoped=true"
import script from "./FooterNavigation.vue?vue&type=script&lang=js"
export * from "./FooterNavigation.vue?vue&type=script&lang=js"
import style0 from "./FooterNavigation.vue?vue&type=style&index=0&id=0e71a604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e71a604",
  null
  
)

export default component.exports